<script setup>
const { data: stops, status } = useLazyAsyncData(
  'stop-points',
  () => {
    return $fetch('/api/stops')
  },
  {
    server: false,
  },
)
// Data is fetched client-side only (`server: false`), so on the server `status`
// is 'idle' (no data yet) — treat that as loading too, otherwise the server
// renders the loaded state while the client renders the skeleton (hydration mismatch).
const pending = computed(
  () => status.value === 'idle' || status.value === 'pending',
)
</script>

<template>
  <article>
    <Head>
      <Title>{{ 'Arrêts – VMCV Timetable' }}</Title>
    </Head>
    <AppArticleHeader :pending="pending">
      {{ 'Liste des Arrêts' }}
    </AppArticleHeader>
    <section>
      <StopList :pending="pending" :stops="stops" />
    </section>
  </article>
</template>
